<his-plam [hisDdKey]="dDKey">
	<div class="selectContainer">
		<p-autoComplete #content
			[hisDdKey]="dDKey"
			[(ngModel)]="publisher"
			[suggestions]="filteredPublishers"
			field="label"
			[forceSelection]="true"
			[size]="30"
			[minLength]="1"
			(completeMethod)="filterPublisher($event)"
			(onSelect)="addPublisher()"
			(onClear)="onClear()">
		</p-autoComplete>
		
		<!-- edit publisher -->
	    <a *ngIf="publisher?.id && auth.hasAnyArray(moduleOptions.RIGHT_EDIT)"
			[routerLink]="['/pub/publisher/edit/', publisher.id]" [queryParams]="{fromForm: true}" class="transparent"
			(click)="onBeforeNavigate()" hisImage="PENCIL">{{'fs.res.publication.publisher.edit' | hisUi}}</a>
		
		<!-- create new publisher -->
		<a *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_CREATE)" (click)="onBeforeNavigate()" [routerLink]="['/pub/publisher/create/']" [queryParams]="{fromForm: true}" hisImage="context_add" class="transparent">
			<span>{{'fs.res.publication.publisher.search.create' | hisUi}}</span>
		</a>
	</div>
</his-plam>
